import React,{Component} from 'react'

import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  Typography,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

export default class SkeletonCard extends Component{
  render(){
    const {media,header,content,actions} = this.props;
    return(
      <Fade in={true}>
        <Card className='skeletonCard card'>
          {!!media &&
            <CardMedia
              className='mediaSkeleton'
              title='skeletonMedia'
              image='...'
            />
          }
          {!!header &&
            <CardHeader
              title=' ~ '
              subheader=' ~ '
              classes={{
                title: 'titleSkeleton',
                subheader: 'subheaderSkeleton',
              }}
              avatar={
                <Avatar
                  className='avatarSkeleton'
                />
              }
            />
          }
          {(!!header && !!content)  && <Divider light />}
          {!!content &&
            <CardContent>
              <Typography className='titleSkeleton'> ~ </Typography>
              <Typography className='titleSkeleton'> ~ </Typography>
              <Typography className='titleSkeleton'> ~ </Typography>
            </CardContent>
          }
          {!!actions &&
            <CardActions className='cardActions'>
              <Button disabled className="cardActionsBtn avatarSkeleton"> ~ </Button>
            </CardActions>
          }
        </Card>
      </Fade>
    )
  }
}

// import SkeletonCard from '../components/SkeletonCard'
// <SkeletonCard header={true} content={true} actions={true} />



// WEBPACK FOOTER //
// ./src/components/SkeletonCard.js